import * as React from 'react';
import { LocalizedDateTime, DateTimeAccuracy } from '../../../misc/components/LocalizedDateTime';
import { AnalysisAcceptabilityStatus } from '../../../misc/components/analysis/AnalysisAcceptabilityStatus';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser, faSquarePen, faThumbtack } from '@fortawesome/free-solid-svg-icons';
import { useSecurityContext } from "../../../Core/SecurityContext";
import { PermissionEnum } from "../../../misc/api/ApiPermissionEnum";

export interface AnalysisSetCardProps {
    id: string;
    type: string;
    disabled: boolean;
    createdDateTime: string;
    analyst: string;
    acceptability: string;
    checked: boolean;
    onAnalysisSetSelect: (checked: boolean) => void;
    isCurrentSet: boolean;
    isBlinded: boolean;
}

export const AnalysisSetCard = (props: AnalysisSetCardProps) => {

    const { currentUserPermissions } = useSecurityContext();

    const ViewCoughAnalyst = () => {
        return currentUserPermissions.some(x => (x.Id === PermissionEnum.ViewCoughAnalyst));
    }


    const renderAnalyst = () => {
        if (props.analyst && ViewCoughAnalyst()) {
            return <div><FontAwesomeIcon icon={faUser} /> {props.analyst}</div>;
        } else {
            return null;
        }
    }

    const onChange = (e) => {
        if (props.isBlinded) {
            return false;
        }
        props.onAnalysisSetSelect(!props.checked);
    }

    const currentIndicatorLabel = props.isCurrentSet ? <span className="label label-primary">Current Set</span> : null;
    const icon = props.disabled ? <i className="fas fa-thumbtack" aria-hidden="true"></i> : <i className="fas fa-pen-square" aria-hidden="true"></i>

    return (
        <li>
            <input id={props.id} type="checkbox" disabled={props.disabled} checked={props.checked} onChange={onChange} />
            <label htmlFor={props.id}>
                <span className="posh-select-icon">{icon}</span>
                <span className="posh-select-body">
                    <span className="posh-select-title">{props.type} {currentIndicatorLabel}</span>
                    <div className="row">
                        {props.isBlinded && (
                            <div className="col-md-8">
                                <p className="text-warning">QC layer is blinded in the current workflow</p>
                            </div>
                        )}
                        <div className="col-md-8">
                            <div><LocalizedDateTime time={props.createdDateTime} accuracy={DateTimeAccuracy.Second} isTooltip={true} /></div>
                            {renderAnalyst()}
                        </div>
                        <div className="col-md-4">
                            <AnalysisAcceptabilityStatus value={props.acceptability} />
                        </div>
                    </div>
                </span>
            </label>
        </li>
    );
}
